import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  // selectedTabIndex: number;
}

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  // selectedTabIndex: 0
};

export const financeUpdateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    // case Constants.PAGE_FINANCE_UPDATE_SWITCH_TAB:
    //   return {
    //     ...state,
    //     selectedTabIndex: action.payload?.index
    //   };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
